import { ReactNode } from 'react';

import styles from './header.module.css';

interface SocialLinkProps {
  href: string;
  icon: ReactNode;
}

const SocialLink = ({ href, icon }: SocialLinkProps) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.socialLink}
    >
      {icon}
    </a>
  );
};

export default SocialLink;
